import "./Sidebar.css";
import OptionSidebar from "../OptionSidebar/OptionSidebar";
import SocialSideBar from "../SocialSidebar/SocialSidebar";
import { useContext, useEffect, useState } from "react";
import { logoutApp } from "../../../../global/context/action/auth/logoutApp";
import { logoutPaciente } from "../../../context/Actions/paciente/paciente";
import { useHistory } from "react-router";
import { PortalContext } from "../../../context/Provider";
import { misMedicosReset } from "../../../context/Actions/misMedicos/misMedicos";
import { misInformesReset } from "../../../context/Actions/misInformes/misInformes";
import { misLaboratoriosReset } from "../../../context/Actions/misLaboratorios/misLaboratorios";
import { resetTurnosPaciente } from "../../../context/Actions/turnos/turnosPaciente";
import { grupoFamiliarReset } from "../../../context/Actions/grupoFamiliar/grupoFamiliar";
import { localidadReset } from "../../../context/Actions/localidad/localidad";
import { resetMultitab } from "../../../context/Actions/multiTab/multiTab";
import { resetLaboGrupo } from "../../../context/Actions/laboGrupo/laboGrupo";
import { resetEstudioGrupo } from "../../../context/Actions/estudioGrupo/estudioGrupo";
import { resetListaFamiliares } from "../../../context/Actions/listaFamiliares/listasFamiliares";
import { tokenLogout } from "../../../context/Actions/token/logoutToken";
import { recetasDigitalesReset } from "../../../context/Actions/turnos/recetaDigital";
import { certificadosReset } from "../../../context/Actions/certificado/certificado";
import { resetDropdown } from "../../../context/Actions/DropDownFamiliares/selectFamiliares";
import { dispositivoPacienteReset } from "../../../context/Actions/dispositivoPaciente/dispositivoPaciente";
import { GlobalContext } from "../../../../global/context/Provider";
import { wsPostLogoutTraza } from "global/context/action/auth/loginTraza";
import { useLocation } from "react-router";
import { ContainerSidebar } from "./localStyle";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import { filterContents } from "./sidebarFun";
import EstudioIcon from "_+_Portal/assets/images/generico/EstudioIcon";
import LaboratorioIcon from "_+_Portal/assets/images/generico/LaboratorioIcon";
import RecetaDigitalIcon from "_+_Portal/assets/images/generico/RecetaDigitalIcon";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import VideoConsultaIcon from "_+_Portal/assets/images/generico/VideoConsultaIcon";
import AtencionSinTurnoIcon from "_+_Portal/assets/images/generico/AtencionSinTurnoIcon";
import TestPcrIcon from "_+_Portal/assets/images/generico/TestPcrIcon";
import OncologiaIcon from "_+_Portal/assets/images/generico/OncologiaIcon";
import OrdenesDigitalesIcon from "_+_Portal/assets/images/generico/OrdenesDigitalesIcon";
import MisLaboratoriosIcon from "_+_Portal/assets/images/generico/MisLaboratoriosIcon";
import MiInformeIcon from "_+_Portal/assets/images/generico/MiInformeIcon";
import MiPerfilIcon from "_+_Portal/assets/images/generico/MiPerfilIcon";
import MiGrupoFamiliarIcon from "_+_Portal/assets/images/generico/MiGrupoFamiliarIcon";
import MiMedicoIcon from "_+_Portal/assets/images/generico/MiMedicoIcon";
import SugerenciaIcon from "_+_Portal/assets/images/generico/SugerenciaIcon";
import VideoTutorial from "_+_Portal/assets/images/generico/VideoTutorial";
import AyudaPreguntaIcon from "_+_Portal/assets/images/generico/AyudaPreguntaIcon";
import PhoneIcon from "_+_Portal/assets/images/generico/PhoneIcon";
import SearchIcon from "_+_Portal/assets/images/generico/SearchIcon";
import RecetaIcon from "_+_Portal/assets/images/generico/RecetaIcon";
import ClipboardMinusIcon from "_+_Portal/assets/images/generico/ClipboardMinusIcon";

const Sidebar = ({ nextFnc }) => {
  const {
    pacienteDispatch,
    misMedicosDispatch,
    misInformesDispatch,
    misLaboratoriosDispatch,
    turnosPacienteDispatch,
    grupoFamiliarDispatch,
    localidadDispatch,
    multiTabDispatch,
    laboGrupoDispatch,
    estudioGrupoDispatch,
    listaFamiliaresDispatch,
    tokenDispatch,
    recetasDigitalesDispatch,
    certificadoDispatch,
    selectDropDownDispatch,
    dispositivoPacienteDispatch,
  } = useContext(PortalContext);

  const { authDispatch, authState, configState } = useContext(GlobalContext);
  const history = useHistory();
  const location = useLocation();
  const [cmpList, setCmpList] = useState(null);

  // Detectar si estamos en el módulo autocheckin para ocultar sidebar
  const isAutocheckin = location.pathname.startsWith("/autocheckin");

  const logoutHome = () => {
    if (authState.authTraza.data !== null) {
      wsPostLogoutTraza(authState.authTraza.data.id, {
        ingreso: false,
        sector: configState.config.data.sectorTurno,
      })(authDispatch);
    }
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    tokenLogout(history)(tokenDispatch);
    misMedicosReset()(misMedicosDispatch);
    misInformesReset()(misInformesDispatch);
    misLaboratoriosReset()(misLaboratoriosDispatch);
    resetTurnosPaciente()(turnosPacienteDispatch);
    grupoFamiliarReset()(grupoFamiliarDispatch);
    localidadReset()(localidadDispatch);
    resetMultitab()(multiTabDispatch);
    resetLaboGrupo()(laboGrupoDispatch);
    resetEstudioGrupo()(estudioGrupoDispatch);
    resetListaFamiliares()(listaFamiliaresDispatch);
    recetasDigitalesReset()(recetasDigitalesDispatch);
    certificadosReset()(certificadoDispatch);
    resetDropdown()(selectDropDownDispatch);
    dispositivoPacienteReset()(dispositivoPacienteDispatch); // ✅ Reset del estado de dispositivo
  };

  useEffect(() => {
    if (configState.config.data !== null) {
      let removeFromTheSidebar = [
        {
          link: "/estudios",
          active: configState.config.data.opcEstudios,
        },
        {
          link: "/misInformes",
          active: configState.config.data.opcEstudios,
        },
        {
          link: "/consultamedica",
          active: configState.config.data.opcConsultasMedicas,
        },
        {
          link: "/laboratorio",
          active: configState.config.data.opcLaboratorio,
        },
        {
          link: "/misLaboratorios",
          active: configState.config.data.opcMisLaboratorios,
        },
        {
          link: "/videoConsulta",
          active: configState.config.data.opcVideoLlamada,
        },
        {
          link: "/recetasdigitales",
          active: configState.config.data.opcRecetaDigital,
        },
        {
          link: "/videoTutoriales",
          active: configState.config.data.opcVideotutoriales,
        },
        {
          link: "/atencionSinTurno",
          active: configState.config.data.opcAtencionSinTurnoPrevio,
        },
        {
          link: "*ayuda*",
          active: configState.config.data.opcBot ?? false,
        },
        {
          link: "/oncologia",
          active: configState.config.data.opcOncologia,
        },
        {
          link: "/testpcr",
          active: configState.config.data.opcAccesoTestRapidoPCR,
        },
        {
          link: "/recetasdigitales",
          active: configState.config.data.opcRecetaDigital,
        },
        {
          link: "/beneficiosDim",
          active: configState.config.data.opcBeneficios,
        },
        {
          link: "/buscadorTurnos",
          active: configState.config.data.opcBuscadorTurnos,
        },
        {
          link: "/autocheckin",
          active: configState.config.data.opcHome,
        },
        {
          link: "/consultamedica",
          active: !configState.config.data.opcBuscadorTurnos,
        },
        {
          link: "/estudios",
          active: !configState.config.data.opcBuscadorTurnos,
        },
        {
          link: "/laboratorio",
          active: !configState.config.data.opcBuscadorTurnos,
        },
        {
          link: "/ordenesDigitales",
          active: configState.config.data.opcOrdenDigital,
        },
        {
          link: "/misRecetas",
          active: configState.config.data.opcMisRecetas,
        },
        {
          link: "/preguntasFrecuentes",
          active: configState.config.data.opcPreguntasFrecuentes ?? true,
        },
      ];

      const componentToRender = {
        titles: ["Turnos", "Resultados", "Información"],
        contents: [
          [
            {
              title: "Buscador Turnos",
              icon: <SearchIcon color={"var(--color-latex10)"} />,
              link: "/buscadorTurnos",
            },
            {
              title: "Consultas Médicas",
              icon: <ConsultaIcon color={"var(--color-latex10)"} />,
              link: "/consultamedica",
            },
            {
              title: "Estudios",
              icon: <EstudioIcon color={"var(--color-latex10)"} />,
              link: "/estudios",
            },
            {
              title: "Laboratorio",
              icon: <LaboratorioIcon color={"var(--color-latex10)"} />,
              link: "/laboratorio",
            },
            {
              title: "Recetas digitales",
              icon: <RecetaDigitalIcon color={"var(--color-latex10)"} />,
              link: "/recetasdigitales",
            },
            {
              title: "Próximos turnos",
              icon: <MiTurnoIcon color={"var(--color-latex10)"} />,
              link: "/proximosTurnos",
            },
            {
              title: "Video consulta",
              icon: <VideoConsultaIcon color={"var(--color-latex10)"} />,
              link: "/videoConsulta",
            },
            {
              title: "Atención sin turno",
              icon: <AtencionSinTurnoIcon color={"var(--color-latex10)"} />,
              link: "/atencionSinTurno",
            },
            {
              title: "Test PCR (COVID-19)",
              icon: <TestPcrIcon color={"var(--color-latex10)"} />,
              link: "/testpcr",
            },
            {
              title: "Oncología",
              icon: <OncologiaIcon color={"var(--color-latex10)"} />,
              link: "/oncologia",
            },
          ],
          [
            {
              title: "Mis laboratorios",
              icon: <MisLaboratoriosIcon color={"var(--color-latex10)"} />,
              link: "/misLaboratorios",
            },
            {
              title: "Mis informes",
              icon: <MiInformeIcon color={"var(--color-latex10)"} />,
              link: "/misInformes",
            },
          ],
          [
            {
              title: "Mi perfil",
              icon: <MiPerfilIcon color={"var(--color-latex10)"} />,
              link: "/perfil",
            },
            {
              title: "Mi grupo familiar",
              icon: <MiGrupoFamiliarIcon color={"var(--color-latex10)"} />,
              link: "/GrupoFamiliar",
            },
            {
              title: "Mis médicos",
              icon: <MiMedicoIcon color={"var(--color-latex10)"} />,
              link: "/misMedicos",
            },
            {
              title: "Beneficios",
              icon: <SugerenciaIcon color={"var(--color-latex10)"} />,
              link: "/beneficiosDim",
            },
            {
              title: "Hacer sugerencias",
              icon: <SugerenciaIcon color={"var(--color-latex10)"} />,
              link: "/sugerencia",
            },
            {
              title: "Preguntas frecuentes",
              icon: <AyudaPreguntaIcon color={"var(--color-latex10)"} />,
              link: "/preguntasFrecuentes",
            },
            {
              title: "Video tutoriales",
              icon: <VideoTutorial color={"var(--color-latex10)"} />,
              link: "/videoTutoriales",
            },
            {
              title: "Ayuda",
              icon: <PhoneIcon color={"var(--color-latex10)"} />,
              link: "*ayuda*",
              fun: () => {
                window.open("https://wa.me/+5491166485555", "_blank");
              },
            },
            // {
            //   title: "Salir",
            //   icon: <SalirIcon color={"var(--color-latex10)"} />,
            //   link: "/",
            // },
          ],
        ],
      };

      componentToRender.contents = componentToRender.contents.map((content) => {
        return filterContents(removeFromTheSidebar, content);
      });

      // Tuve que hacerlo aparte estas exclusiones ya que se comportan diferente a los demas
      // items del sidebar, estos son titulos directamente
      if (configState.config.data.opcOrdenDigital) {
        componentToRender.titles.push("Ordenes Médicas");
        componentToRender.contents.push([
          {
            title: "Ordenes digitales",
            icon: <OrdenesDigitalesIcon color={"var(--color-latex10)"} />,
            link: "/ordenesDigitales",
          },
        ]);
      }
      if (configState.config.data.opcMisRecetas) {
        componentToRender.titles.push("Ver Recetas");
        componentToRender.contents.push([
          {
            title: "Mis Recetas",
            icon: <RecetaIcon color={"var(--color-latex10)"} />,
            link: "/misRecetas",
          },
        ]);
      }
      if (configState.config.data.opcCertificados) {
        componentToRender.titles.push("Ver Certificados");
        componentToRender.contents.push([
          {
            title: "Ver Certificados",
            icon: <ClipboardMinusIcon color={"var(--color-latex10)"} />,
            link: "/certificados",
          },
        ]);
      }
      setCmpList(componentToRender);
    }
  }, [configState.config.data]);

  if (isAutocheckin) return null;

  return (
    <ContainerSidebar className="ptur-sidebarDiv bgc-grey97">
      {configState.config.data !== null && cmpList !== null && (
        <OptionSidebar
          componentToRender={cmpList}
          logoutHome={logoutHome}
          nextFnc={nextFnc}
        />
      )}
      <SocialSideBar />
    </ContainerSidebar>
  );
};

export default Sidebar;
